import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsCountByTag = QueryFactory(SD.QueryTypes.GetEventsCountByTag);
//# sourceMappingURL=GetEventsCountByTag.js.map